export interface IRouter {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  go(path: string, options: any): void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  href(path: string, options: any): string;
  current: {
    name: string;
  };
}
